module.exports = __webpack_public_path__ + "b48fad80f5ada2aea347e24c1450d906.svg";